import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const PopperContainer = styled.div`
	min-height: 5rem;
	max-height: ${(props) => (props.maxHeight ? `min(20rem, calc(${props.maxHeight}px - 5.5rem))` : '20rem')};
	min-width: 60rem;
	overflow-y: scroll;
	overflow-x: hidden;

	background-color: var(--modal-bg-3);
	border-radius: var(--small-border-radius);
	z-index: var(--z-index-10);
	box-shadow: var(--container-box-shadow);

	@media ${Breakpoints.mobile} {
		min-width: 93%;
		max-width: 93%;
	}
`;

export const Table = styled.div`
	display: flex;
	flex-direction: column;
	padding: var(--padding-2);
	border-radius: var(--small-border-radius);
	background-color: var(--modal-bg-3);
`;

export const Row = styled.div`
	display: flex;
	align-items: center;
	border-radius: var(--small-border-radius);
	padding: var(--padding-1) var(--padding-3);
	cursor: pointer;

	:hover {
		background-color: var(--table-selected-color);
	}
`;

export const SearchInputContainer = styled.div`
	.expandable {
		> input {
			width: 30rem !important;
			min-height: unset !important;
			height: 4.1rem !important;
			padding: 0.7rem 4rem !important;

			body[dir='rtl'] & {
				padding: 0.6rem 4rem !important;
			}
		}

		:hover,
		:active,
		:focus,
		:focus-within {
			> input {
				width: 60rem !important;
			}
		}
	}
`;
